import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gray-50 py-4 mt-16">
      <p className="text-center text-sm text-gray-500">
        © 2025 International Biblical Onomastic Society.
      </p>
    </footer>
  );
}
